import { Link } from "react-router-dom";
import { ArrowLeft, Newspaper } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Seo } from "@/components/Seo";
import { Reveal } from "@/components/Reveal";

export default function Blog() {
  return (
    <div className="min-h-screen overflow-x-clip bg-crave-bg font-sans text-crave-cream">
      <Seo
        title="Blog | Foodie Crave: Discover & Dine"
        description="Stories, updates, and dining inspiration from the Foodie Crave team — coming soon."
        path="/blog"
        robots="noindex, follow"
      />
      <Navbar />
      <main>
        <section className="relative overflow-hidden pt-32 pb-24 md:pt-44 md:pb-32" data-testid="blog-page">
          <div
            aria-hidden="true"
            className="pointer-events-none absolute -top-48 -left-48 h-[36rem] w-[36rem] rounded-full bg-crave-red/25 blur-[140px]"
          />
          <div className="relative mx-auto max-w-3xl px-6 md:px-12">
            <Reveal>
              <span className="flex h-12 w-12 items-center justify-center rounded-full border border-crave-gold/30 bg-crave-gold/10 text-crave-gold">
                <Newspaper className="h-5 w-5" aria-hidden="true" />
              </span>
              <p className="mt-6 text-xs font-bold uppercase tracking-[0.28em] text-crave-gold">Blog</p>
              <h1 className="mt-4 font-display text-4xl font-medium leading-[1.05] tracking-tight text-crave-cream sm:text-5xl md:text-6xl">
                Stories from the table are coming soon
              </h1>
              <p className="mt-6 max-w-xl text-base leading-relaxed text-crave-muted md:text-lg">
                We're working on launch updates, dining inspiration, and behind-the-scenes notes
                from the Foodie Crave kitchen. Check back around launch — or join early access and
                we'll let you know when the first story is served.
              </p>
              <Link
                to="/"
                data-testid="blog-home-link"
                className="mt-10 inline-flex items-center gap-2.5 rounded-full bg-crave-gold px-7 py-3.5 text-sm font-bold text-crave-bg transition-colors duration-300 hover:bg-crave-cream"
              >
                <ArrowLeft className="h-4 w-4" aria-hidden="true" />
                Back to home
              </Link>
            </Reveal>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
